export const messages = {
  username: {
    placeholder: {
      id: 'login.Form.Username.Placeholder',
      defaultMessage: 'Enter Username',
    },
  },
  password: {
    placeholder: {
      id: 'login.Form.Password.Placeholder',
      defaultMessage: 'Enter Password',
    },
  },
  login: {
    label: {
      id: 'login.Form.Login.Label',
      defaultMessage: 'Log in',
    },
  },
  signup: {
    label: {
      id: 'login.Signup.Label',
      defaultMessage: 'Create your account',
    },
    description: {
      id: 'login.Signup.Description',
      defaultMessage: 'See your health info, view appointments, learn about your condition, and more.',
    },
    button: {
      createAccount: {
        id: 'login.Signup.Button.CreateAccount',
        defaultMessage: 'Create account',
      },
      description: {
        id: 'login.Signup.Button.Description',
        defaultMessage: 'Opens on a new screen.',
      },
    },
  },
  forgotPassword: {
    label: {
      id: 'login.Form.ForgotPassword.Label',
      defaultMessage: 'Forgot password?',
    },
  },
  usernameTitle: {
    label: {
      id: 'login.Form.UserNameTitle.Label',
      defaultMessage: 'Username',
    },
  },
  passwordTitle: {
    label: {
      id: 'login.Form.PasswordTitle.Label',
      defaultMessage: 'Password',
    },
  },
  required: {
    error: {
      id: 'login.Form.Required.Error',
      defaultMessage: 'Required',
    },
  },
  page: {
    title: {
      id: 'login.Page.Title',
      defaultMessage: '{facilityPortalName}',
    },
  },
};
